<template>
    <div contenteditable="true" @input="updateHTML">  
        <label>{{ label }}</label>
    </div>
</template>

<script>
    export default {
        name: "HtmlInputText",
        props:['value', 'label'],
        mounted: function () {
            this.$el.innerHTML = this.value;
        },
        methods: {
            updateHTML: function(e) {
              this.$emit('input', e.target.innerHTML);
            }
        }
    }
</script>

<style scoped>
    div {
        border: none !important;
    }
</style>
